import type { PlanPriceData } from '@jobilla/nexus-sdk'

export function formatPrice(price: PlanPriceData, locale: string): string {
	const hasCents = price.amount % 100 !== 0

	return new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: price.currency.toUpperCase(),
		minimumFractionDigits: hasCents ? 2 : 0,
		maximumFractionDigits: hasCents ? 2 : 0,
	}).format(price.amount / 100)
}
